import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FilterSelectionStorageService {
  readIds(key: string): string[] {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) {
        return [];
      }
      const parsed: unknown = JSON.parse(raw);
      if (!Array.isArray(parsed)) {
        return [];
      }
      return parsed.filter((id): id is string => typeof id === 'string' && id.trim().length > 0);
    } catch {
      return [];
    }
  }

  writeIds(key: string, ids: string[]): void {
    localStorage.setItem(key, JSON.stringify(ids));
  }
}

export const FILTER_STORAGE_KEYS = {
  cvthequeConseillers: 'imatch.filters.cvtheque.conseillerIds',
  offresCommercials: 'imatch.filters.offres.commercialIds',
  entreprisesCommercials: 'imatch.filters.entreprises.commercialIds',
  entretiensConseillers: 'imatch.filters.entretiens.conseillerIds',
  matchingConseillers: 'imatch.filters.matching.conseillerIds',
} as const;
